<template>
    <div id="overlay"></div>
</template>